// extracted by mini-css-extract-plugin
export default {"active":"ActiveStatusBadge_active__BLHL-","inactive":"ActiveStatusBadge_inactive__NcAEt"};